import React from "react";
import { Check, Clear } from "@mui/icons-material";
import { Chip } from "@mui/material";

const BooleanChip = ({ value }) => {
  return value
    ? (
      <Chip size="small" icon={<Check />} label="Yes" color="success" />
    )
    : (
      <Chip size="small" icon={<Clear />} label="No" color="error" />
    );
};

export default BooleanChip;
